import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Button,
    TextField,
    colors,
    DialogTitle,
    Paper,
    Divider,
} from "@material-ui/core";
import { useStylesLbl } from "../../../../../St/Reports/UseStyle";
import ItemsDetailsFilter from "../ItemInfo/ItemsDetailsFilter";
import { useStylesTF } from "../../../../../St/comps/UseStyle";
import { useStylesItemDilog } from "../ItemDataDialog";
import { uri } from "../../../../../help/Api";
import { sto } from "../../../../../Context/InshData";
import axios from "axios";
import { ArrowDownward } from "@material-ui/icons";
import { SharedGroupIdProvider } from "../../InvoiceRest/RestProductsG";
import TawlaList from "./TawlaList";
import GroupLists from "../../InvoiceRest/GroupLists";

export default function GetTawla(props) {
    const { openTawla, setOpenTawla,idata, setIData,tawlaGroups,setTawlaGroups} = props;
    const classes = useStylesItemDilog();
    const [defColor, setDefColor] = React.useState({id:-1});
    const [tawlaGroupId, setTawlaGroupId] = React.useState(0);
    const [tawla, setTawla] = React.useState([]);

    const onSelect =  (row) => {
        setIData({...idata,tawla_group_no:tawlaGroupId,tawla:row.id, tawlaName:row.Name});
        setOpenTawla(false);
    };
    const [loading, setLoading] = useState(false);
    const getCloseDialog=()=>{
        setOpenTawla(false);
    }
    const getFromUrl= async(tname,id)=>{
        const tb = {
            Tawla: true,
            parms: {
                tname:tname,
                branch: sto.branchi,
                id: id,
                db_name:sto?.db_name
            },
        };
        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                const dataItems = res.data.tawla.map((row, i) => {
                    return {
                        ...row,
                        color:-1,
                        name:row.Name,
                    };
                });
                if (tname==="search2"){
                    setTawla(dataItems);
                    setTawlaGroupId(id);
                }else{ setTawlaGroups(dataItems);}
            })
            .catch((error) => {
            });
    }
    const onTawlaClick =  (row) => {
        getFromUrl("search2",row.id);
    };

    const GetTawlas =  () => {
        getFromUrl("search1",-1);;
    };
    useEffect(() => {
        if (tawlaGroups.length==0){
            GetTawlas();
        }
    }, [tawlaGroups]);
    return (
        <Dialog open={openTawla}  classes={{ paper: classes.dialogTawla }}>
            <DialogTitle style={{ textAlign: "center" }} > {"طاولات المطعم"}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container justifyContent="center" spacing={1} item lg={12} md={12} sm={12} xs={12}  style={{width:"100%"}}>
                    
                    <Grid item lg={8} md={8} sm={8} xs={8}>
                        <Paper style={{ minHeight: "30vh", maxHeight: "30vh",width:"100%"  }}>
                            <SharedGroupIdProvider>
                                <TawlaList
                                    onSelectItem={onSelect}
                                    loading={loading}
                                    data={tawla ? tawla : []}
                                />
                            </SharedGroupIdProvider>
                        </Paper>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Paper  style={{ minHeight: "30vh", maxHeight: "30vh", overflow: "auto",width:"100%" }} >
                            <SharedGroupIdProvider>
                                <GroupLists
                                    groups={[...tawlaGroups]}
                                    onRowClick={onTawlaClick}
                                    isMain={true}
                                    GroupColor={defColor}
                                />
                                <Divider />
                            </SharedGroupIdProvider>
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button onClick={() => getCloseDialog()}>إغلاق </Button>
            </DialogActions>
        </Dialog>
    );
}

